// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Numbers from "layouts/numbers";
import Punches from "layouts/punches";
import Contractors from "layouts/contractors";
import QrCode from "layouts/qrCode";
import Companies from "layouts/companies";
import Profile from "layouts/profile";
import QrCodeClockIn from "layouts/qrCodeClockIn";
import Settings from "layouts/settings";
import SignIn from "layouts/authentication/sign-in";
import ThankYou from "layouts/thankyou";

import Device from "layouts/device";
// import DeviceClockIn from "layouts/deviceClockIn";

// @mui icons
import Icon from "@mui/material/Icon";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import QrCodeIcon from "@mui/icons-material/QrCode";
import DeviceIcon from "@mui/icons-material/TabletAndroid";
import { EmojiPeopleOutlined } from "@mui/icons-material";

const routes = [
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/",
    authorized: false,
    displayOnSidebar: false,
    component: <SignIn />,
    redirect: () => "/dashboard",
  },
  {
    type: "collapse",
    name: "Thank you",
    key: "thank-you",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/thank-you",
    authorized: false,
    displayOnSidebar: false,
    component: <ThankYou />,
    redirect: () => "/dashboard",
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    authorized: true,
    displayOnSidebar: true,
    component: <Dashboard />,
    redirect: () => "/",
    roles: ["ROLE_USER", "ROLE_ADMIN", "ROLE_SUPER_ADMIN"],
  },
  {
    type: "collapse",
    name: "Whitelist Number",
    key: "whitelist",
    icon: <Icon fontSize="small">phone</Icon>,
    route: "/whitelist",
    authorized: true,
    displayOnSidebar: true,
    component: <Numbers />,
    redirect: () => "/",
    roles: ["ROLE_USER", "ROLE_ADMIN"],
  },
  {
    type: "collapse",
    name: "QR Code",
    key: "qr-codes",
    icon: <QrCodeIcon fontSize="small" />,
    route: "/qr-codes",
    authorized: true,
    displayOnSidebar: true,
    component: <QrCode />,
    redirect: () => "/",
    roles: ["ROLE_USER", "ROLE_ADMIN"],
  },
  {
    type: "collapse",
    name: "Physical Clocks",
    key: "devices",
    icon: <DeviceIcon fontSize="small" />,
    route: "/devices",
    authorized: true,
    displayOnSidebar: true,
    component: <Device />,
    redirect: () => "/",
    roles: ["ROLE_USER", "ROLE_ADMIN"],
  },
  {
    type: "collapse",
    name: "Employees Timesheet",
    key: "punches",
    icon: <HistoryToggleOffIcon fontSize="small" />,
    route: "/punches/employee",
    authorized: true,
    displayOnSidebar: true,
    component: <Punches type="employee" />,
    redirect: () => "/",
    roles: ["ROLE_USER", "ROLE_ADMIN"],
  },
  {
    type: "collapse",
    name: "Contractor Timesheet",
    key: "contractorPunches",
    icon: <HistoryToggleOffIcon fontSize="small" />,
    route: "/punches/contractor",
    authorized: true,
    displayOnSidebar: true,
    component: <Punches type="contractor" />,
    redirect: () => "/",
    roles: ["ROLE_USER", "ROLE_ADMIN"],
  },
  {
    type: "collapse",
    name: "Contractors",
    key: "contractors",
    icon: <EmojiPeopleOutlined fontSize="small" />,
    route: "/contractors",
    authorized: true,
    displayOnSidebar: true,
    component: <Contractors />,
    redirect: () => "/",
    roles: ["ROLE_ADMIN"],
  },
  {
    type: "collapse",
    name: "Companies",
    key: "companies",
    authorized: true,
    displayOnSidebar: true,
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/billing",
    component: <Companies />,
    roles: ["ROLE_SUPER_ADMIN"],
    redirect: () => "/",
  },
  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    authorized: true,
    displayOnSidebar: true,
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/settings",
    component: <Settings />,
    roles: ["ROLE_ADMIN"],
    redirect: () => "/",
  },
  {
    type: "collapse",
    name: "My Profile",
    key: "my-profile",
    authorized: true,
    displayOnSidebar: false,
    icon: <Icon fontSize="small">person</Icon>,
    route: "/my-profile",
    component: <Profile />,
    roles: ["ROLE_USER", "ROLE_ADMIN", "ROLE_SUPER_ADMIN"],
    redirect: () => "/",
  },
  {
    type: "collapse",
    name: "QR Code Clock In",
    key: "qr-code-clock-in",
    icon: null,
    route: "/qr-code-clock-in/:id",
    authorized: false,
    displayOnSidebar: false,
    component: <QrCodeClockIn />,
    // redirect: () => "/",
  },
  // {
  //   type: "collapse",
  //   name: "Device Clock In",
  //   key: "device-clock-in",
  //   icon: null,
  //   route: "/device-clock-in/:id",
  //   authorized: false,
  //   displayOnSidebar: false,
  //   component: <DeviceClockIn />,
  //   // redirect: () => "/",
  // },
];

export default routes;
